import { trackEventPendo } from "Store/analytics/pendoTracker";

export const sendPendoEventDialog = ({
  isOpen,
  analyticId
}: {
  isOpen: boolean;
  analyticId?: string;
}) => {
  isOpen &&
    analyticId &&
    trackEventPendo("info_dialog_opened", { value: analyticId });
};

export const sendPendoEventTooltip = (analyticId: string) => {
  trackEventPendo("tooltip_opened", {
    value: analyticId
  });
};

export const sendPendoEventRadio = (analyticId: string) => {
  trackEventPendo("radio_clicked", {
    value: analyticId
  });
};

export const sendPendoEventCheckbox = ({
  check_id,
  value,
  analyticId
}: {
  check_id: string;
  value: boolean;
  analyticId?: string;
}) => {
  trackEventPendo("checkbox_clicked", {
    check_id,
    value,
    analyticId
  });
};

export const sendPendoEventAccordion = (analyticId: string) => {
  trackEventPendo("accordion_status_changed", {
    value: analyticId?.toString()
  });
};

export const sendPendoEventSelect = (
  analyticId: string | undefined,
  selectedValue: string
) => {
  trackEventPendo("select_value_changed", {
    value: analyticId,
    selectedValue
  });
};

export const sendPendoEventDropdown = (analyticId?: string) => {
  trackEventPendo("dropdown_open_changed", {
    value: analyticId
  });
};

export const sendPendoEventDropdownItem = ({
  analyticId,
  type,
  checked
}: {
  type: string;
  analyticId?: string;
  checked?: boolean | "indeterminate";
}) => {
  trackEventPendo(`dropdown_item_type_${type}_selected`, {
    value: analyticId,
    checked
  });
};

export const sendPendoEventTab = ({ analyticId }: { analyticId?: string }) => {
  analyticId && trackEventPendo("tab_active", { value: analyticId });
};
